/** basic-legend-item */

<template>
    <div class="basic-legend-item">
        <div>
            <input type="checkbox" class="legend-checkbox" v-bind:id="layer.layer_name" v-if="layer.allow_control" v-model="checkboxState"/>
        </div>

        <div><img v-bind:src="layer.legend_graphic" alt=""></div>

        <div><label v-bind:for="layer.layer_name">{{ layer.layer_name_display }}</label></div>
    </div>
</template>


<script>
export default {
    name: "basic-legend-item",
    components: {},
    props: {
        layer: {type: Object, required: true}
    },
    data: function () {
        return {
            checkboxState: false
        }
    },
    methods: {
        emitStateChange: function () {
            this.$emit("layer-change", ["single", this.layer.layer_name, this.checkboxState])
        }
    },
    computed: {},
    watch: {},
    mounted: function () {
        this.checkboxState = this.layer.start_enabled;
        this.$watch("checkboxState", this.emitStateChange);  // add the watcher here to avoid firing on initial setup - https://stackoverflow.com/a/58949762/
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .basic-legend-item {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 5px;

        div:first-of-type, div:nth-of-type(2) {
            display: flex;
            flex: 0 0 20px;
            align-items: center;
        }

        div:nth-of-type(2) {
            margin-right: 4px;
        }
    }
</style>